import React from "react";

import Skeleton from "@material-ui/lab/Skeleton";

import "./SkeletonLoader.css";

class SkeletonLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    const loaderArray = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ];
    return (
      <div>
        <React.Fragment>
          <div className="skl-featured-heading">
            <Skeleton animation="wave" height={60} />
          </div>
          <div className="skl-product-wrapper">
            {loaderArray.map((item, index) => (
              <div className="skl-product-item" key={index}>
                <Skeleton animation="wave" height={200} />
                <Skeleton animation="wave" height={40} />
              </div>
            ))}
          </div>
        </React.Fragment>
      </div>
    );
  };
}

export default SkeletonLoader;
